// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.
import fn from '../../differenceInYears/index.js';
import convertToFP from '../_lib/convertToFP/index.js';
var differenceInYears = convertToFP(fn, 2);
export default differenceInYears;


//////////////////
// WEBPACK FOOTER
// ./~/date-fns/esm/fp/differenceInYears/index.js
// module id = 844
// module chunks = 0